import '../App.css';
import { useContext, useEffect } from 'react';
import { Routes, Route, Link, useParams, useLocation } from "react-router-dom";
import { RiHome6Line } from "react-icons/ri";
import { TbHistoryToggle, TbWorldSearch } from "react-icons/tb";
import { MdOutlineLocalConvenienceStore, MdOutlineStore, MdOutlineWarehouse } from "react-icons/md";
import { UserContext } from "../context/UserContext";
import { MenuContext } from '../context/MenuContext';
import { AiOutlineClose } from "react-icons/ai";
import logo from '../images/roscroft_logo.png'
import { FaPlaneDeparture, FaStore, FaUsers } from 'react-icons/fa';
import { LuTicketsPlane, LuUserPlus } from "react-icons/lu";
import { IoKey } from 'react-icons/io5';
import Home from './Home';
import FlightSearch from './FlightSearch';
import ConfirmBooking from './ConfirmBooking';
import MakePayment from './MakePayment';
import CharterSearch from './RequestCharter';
import MyFlights from './MyFlights';
import FlightDetails from './FlightDetails';
import EmptyLegs from './EmptyLegs';
import { IoIosLogOut } from "react-icons/io";
import { useCookies } from 'react-cookie';

export default function Dashboard() {
  const location = useLocation();
  const {logOutFunction} = useContext(UserContext);
  const { menuOpen, setMenuOpen } = useContext(MenuContext)
  const {userProfile, setUserProfile} = useContext(UserContext);
  const [cookies] = useCookies();

  useEffect(() => {
    console.log('user_profile', userProfile);
    if (cookies?.userProfile) {
      setUserProfile(cookies?.userProfile)
    }
  }, [])

  return (
    <div className="flex min-h-screen bg-[#1E1A14]">
      {/* Sidebar */}
      <div className="border-r border-[#C59F59]/10">
        <aside className={`backdrop-blur-sm lg:backdrop-blur-none transition-transform duration-500 fixed lg:relative top-0 bottom-0 h-full z-[50] lg:z-[0] w-full sm:w-[50%] lg:w-64 text-white p-6 space-y-4 ${menuOpen ? 'flex' : 'hidden lg:flex'} flex-col justify-start`}>
          <div className='flex flex-row justify-between items-center gap-y-2 w-full mt-[10px] mb-[20px]'>
              <img src={logo} className="h-auto w-[50%] lg:w-[80%]" alt="logo" />
              <div
                  onClick={() => setMenuOpen(false)}
                  className="block lg:hidden btn btn-ghost btn-circle mb-4 self-end"
              >
                  <AiOutlineClose className="h-7 w-7 text-white" />
              </div>
          </div>
          <nav className="h-full flex flex-col space-y-2 gap-y-1">
            <Link onClick={() => setMenuOpen(false)} to="/dashboard/home" className={`py-2 font-medium flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/home")) ? 'bg-primary text-[#1E1A14] shadow-[0_3px_8px_rgba(216,176,90,0.25)]' : 'text-[#94A3B8]'}`} ><RiHome6Line size={20} color={`${(location.pathname.startsWith("/dashboard/home")) ? '#1E1A14' : '#94A3B8'}`} /> Home</Link>
            {/* <Link onClick={() => setMenuOpen(false)} to="/dashboard/flight-search" className={`py-2 font-medium flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/flight-search")) ? 'bg-primary text-[#1E1A14] shadow-[0_3px_8px_rgba(216,176,90,0.25)]' : 'text-[#94A3B8]'}`} ><TbWorldSearch size={20} color={`${(location.pathname.startsWith("/dashboard/flight-search")) ? '#1E1A14' : '#94A3B8'}`} /> Shared Flights</Link> */}
            <Link onClick={() => setMenuOpen(false)} to="/dashboard/charter-jet" className={`py-2 font-medium flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/charter-jet")) ? 'bg-primary text-[#1E1A14] shadow-[0_3px_8px_rgba(216,176,90,0.25)]' : 'text-[#94A3B8]'}`} ><FaPlaneDeparture size={20} color={`${(location.pathname.startsWith("/dashboard/charter-jet")) ? '#1E1A14' : '#94A3B8'}`} /> Charter Jet</Link>
            <Link onClick={() => setMenuOpen(false)} to="/dashboard/empty-legs" className={`py-2 font-medium flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/empty-legs")) ? 'bg-primary text-[#1E1A14] shadow-[0_3px_8px_rgba(216,176,90,0.25)]' : 'text-[#94A3B8]'}`} ><TbWorldSearch size={20} color={`${(location.pathname.startsWith("/dashboard/empty-legs")) ? '#1E1A14' : '#94A3B8'}`} /> Empty Leg Deals</Link>
            <Link onClick={() => setMenuOpen(false)} to="/dashboard/my-flights" className={`py-2 font-medium flex gap-x-3 items-center px-3 hover:text-white hover:bg-secondary rounded-[7px] ${(location.pathname.startsWith("/dashboard/my-flights")) ? 'bg-primary text-[#1E1A14] shadow-[0_3px_8px_rgba(216,176,90,0.25)]' : 'text-[#94A3B8]'}`} ><LuTicketsPlane size={20} color={`${(location.pathname.startsWith("/dashboard/my-flights")) ? '#1E1A14' : '#94A3B8'}`} /> My Flights</Link>
            
            <div className="flex-1" />
            <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
              <div onClick={() => {logOutFunction();setMenuOpen(false) }} className="flex items-center gap-3 cursor-pointer">
                {/* <div className="h-10 w-10 overflow-hidden rounded-full border border-white/10 bg-white/10">
                  <img
                    src="https://i.pravatar.cc/80?img=12"
                    alt="User avatar"
                    className="h-full w-full object-cover"
                  />
                </div> */}

                <div className="leading-tight">
                  <div className="text-sm font-semibold text-white/85">
                    {userProfile?.first_name}{" "}{userProfile?.last_name}
                  </div>
                  <div className="mt-0.5 text-[11px] text-[#d8b05a]/80">
                    Gold Member
                  </div>
                </div>

                <button
                  className="ml-auto rounded-xl p-2 text-white/45 hover:text-white/80"
                  aria-label="Log out"
                  type="button"
                >
                  <IoIosLogOut name="logout" />
                </button>
              </div>
            </div>
          </nav>
        </aside>
        {menuOpen && <div className={`${menuOpen ? 'flex lg:hidden' : 'hidden'} h-full w-full fixed top-0 bg-[#000000]/50 z-[49]`}>

        </div>}
      </div>

      {/* Main content */}
      <main className="flex-1">
        {/* <ScrollToTop /> */}
        <Routes>
          <Route path="home" element={<Home />} />
          <Route path="flight-search" element={<FlightSearch />} />
          <Route path="flight-search/confirm-booking" element={<ConfirmBooking />} />
          <Route path="flight-search/confirm-booking/pay" element={<MakePayment />} />
          <Route path="empty-legs/confirm-booking" element={<ConfirmBooking />} />
          <Route path="empty-legs/confirm-booking/pay" element={<MakePayment />} />
          <Route path="charter-jet" element={<CharterSearch />} />
          <Route path="empty-legs" element={<EmptyLegs />} />
          <Route path="my-flights" element={<MyFlights />} />
          <Route path="my-flights/:type/:booking_reference" element={<FlightDetails />} />
        </Routes>
      </main>
    </div>
  );
}

